import { Controller } from "@hotwired/stimulus"
import Moment from 'moment';
import Pikaday from 'pikaday';

// Connects to data-controller="cms-item-groups"
export default class extends Controller {

  static targets = []

  connect() {
    this.pikaInit('timetables_item_group_start_date');
    this.pikaInit('timetables_item_group_end_date');
    Moment().format();
    this.classScheduleSelectListener();
    this.endSelectListener();
  }

  pikaInit(fieldID) {
    const pika = new Pikaday({
      field: document.getElementById(fieldID),
      format: 'DD MM YYYY',
      minDate: new Date(),
      toString(date) {
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      },
    });
    pika.getMoment();
  }

  classScheduleSelectListener() {
    const classSheduleSelect = document.querySelector('#timetables_item_group_repeat_type');
    let daysRadios = [...document.querySelectorAll('.item-group__days')];
    let repeatSelect = document.querySelector('.item-group__class-repeats');
    
    classSheduleSelect.addEventListener('change', () => {      
      if(classSheduleSelect.value == 'specified_days'){
        daysRadios.forEach(e => {
          this.show(e);
        });
        this.hide(repeatSelect);
      } else if(classSheduleSelect.value == 'none' || classSheduleSelect.value == '' || classSheduleSelect.value == 'daily' ) {
        daysRadios.forEach(e => {
          this.hide(e);
        });
        this.hide(repeatSelect);
      } else {
        daysRadios.forEach(e => {
          this.hide(e);
        });
        this.show(repeatSelect);
      }
    });
  }

  endSelectListener() {
    let endSelect = document.querySelector('#timetables_item_group_end_method');
    let endDateField = document.querySelector('.item-group__end-date')
    let endSessions = document.querySelector('.item-group__end-sessions')

    endSelect.addEventListener('change', () => {      
      if(endSelect.value == 'end_count'){
        this.show(endSessions)
        this.hide(endDateField);
      } else if(endSelect.value == 'none' || endSelect.value == '') {
        this.hide(endSessions);
        this.hide(endDateField);
      } else {
        this.hide(endSessions);
        this.show(endDateField);
      }
    });
  }

  hide(element){
    element.classList.add('hidden')
    element.classList.remove('show')
  }
  show(element){
    element.classList.add('show')
    element.classList.remove('hidden')
  }


}
